import React from 'react';
import './CV.css';

function CVPL() {
  return (
    <div className="cv-container">
      <header className="cv-header">
        <h1 className="cv-title">UX Designer / UX Researcher / UI Designer / Graphic Designer</h1>
      </header>

      <div className="cv-left">
        <section className="cv-section">
          <h2 className="cv-section-title">Doświadczenie</h2>

          <div className="cv-job">
            <div className="cv-job-title">Freelance UX/UI Designer — Self-Employed</div>
            <div className="cv-job-date">01/2025 -</div>
            <ul className="cv-job-description">
              <li>Designing websites i e-commerce (UX/UI, information architecture, responsive design)</li>
              <li>Tworzenie analitycznych dashboardów i user interfaces opartych na danych</li>
              <li>Opracowywanie wireframes i high-fidelity prototypes w Figma</li>
              <li>Współpraca z klientami i iterowanie projektów w oparciu o feedback i usability principles</li>
            </ul>
          </div>

          <div className="cv-job">
            <div className="cv-job-title">Siemens Digital Logistics, Wrocław — UX/UI Designer</div>
            <div className="cv-job-date">Czerwiec 2019 - Styczeń 2025</div>
            <ul className="cv-job-description">
              <li>Identyfikacja problemów UX w platformach logistycznych SaaS i proponowanie usprawnień projektowych</li>
              <li>Redesign interfejsów mobilnych i desktopowych, poprawa usability i efektywności</li>
              <li>Prowadzenie UX research w celu optymalizacji workflowów i poprawy interakcji użytkowników</li>
              <li>Tworzenie skalowalnych komponentów UI i utrzymanie design systemów dla spójności</li>
              <li>Wdrażanie user insights w strategię produktu i decyzje UX</li>
              <li>Tworzenie interaktywnych prototypów w Figma, usprawniających user flows i interakcje</li>
              <li>Ulepszanie narzędzi i rozwiązań platformowych dla inżynierów, zapewniając płynną współpracę</li>
              <li>Zapewnienie spójności projektowej poprzez dokumentację UI i standaryzację</li>
              <li>Współpraca cross-functional z inżynierami i zespołami produktowymi przy wdrażaniu skalowalnych rozwiązań UX</li>
            </ul>
          </div>

          <div className="cv-job">
            <div className="cv-job-title">OK - Interactive, Gdańsk — Graphic Designer/UI</div>
            <div className="cv-job-date">Wrzesień 2016 - Lipiec 2019</div>
            <ul className="cv-job-description">
              <li>Projektowanie responsywnych stron internetowych, landing pages i aplikacji webowych dla różnych branż</li>
              <li>Tworzenie UI kitów i komponentów projektowych dla spójności marki</li>
              <li>Projektowanie interaktywnych elementów UI i mikrointerakcji zwiększających zaangażowanie</li>
              <li>Optymalizacja projektów mobile-first, zapewniających płynne doświadczenia na różnych urządzeniach</li>
              <li>Praca z Adobe Creative Suite i WordPressem przy realizacji kompleksowych rozwiązań cyfrowych</li>
            </ul>
          </div>

          <div className="cv-job">
            <div className="cv-job-title">Panorama, Gdańsk — Ilustratorka / Graphic Designer</div>
            <div className="cv-job-date">Czerwiec 2011 - Czerwiec 2019</div>
            <ul className="cv-job-description">
              <li>Specjalizacja w projektowaniu materiałów drukowanych: plakaty, pocztówki</li>
              <li>Korekcja kolorów i edycja zdjęć, podnoszenie jakości do druku wysokiej klasy</li>
              <li>Tworzenie ilustracji i grafik wektorowych, elementów dekoracyjnych</li>
              <li>Projektowanie papierów ozdobnych i opakowań, tworzenie autorskich tekstur i wzorów</li>
            </ul>
          </div>

          <div className="cv-job">
            <div className="cv-job-title">Freelance Designer — Własna działalność</div>
            <div className="cv-job-date">Czerwiec 2011 - Czerwiec 2019</div>
            <ul className="cv-job-description">
              <li>Projektowanie stron internetowych, landing pages i interfejsów mobilnych z naciskiem na usability i dostępność</li>
              <li>Tworzenie materiałów brandingowych, UI kitów i grafik marketingowych dla start-upów i firm</li>
              <li>Opracowywanie autorskich ilustracji i grafik wektorowych do projektów cyfrowych i drukowanych</li>
              <li>Ścisła współpraca z klientami i inżynierami, zapewniająca płynne wdrożenie projektów</li>
            </ul>
          </div>
        </section>
      </div>

      <div className="cv-right">
        <section className="cv-section">
          <h2 className="cv-section-title">Wykształcenie</h2>

          <div className="cv-education-entry">
            <div className="cv-education-title">Akademia Sztuk Pięknych, Gdańsk</div>
            <div className="cv-education-institution">Licencjat</div>
            <div className="cv-education-detail">Październik 2007 - Październik 2011</div>
          </div>

          <div className="cv-education-entry">
            <div className="cv-education-title">Sztuka</div>
            <div className="cv-education-institution">Uniwersytet Mikołaja Kopernika, Toruń</div>
            <div className="cv-education-institution">Licencjat</div>
            <div className="cv-education-detail">Październik 2006 - Czerwiec 2011</div>
            <div className="cv-education-detail">Intermedia, stypendium Erasmus w Finlandii</div>
          </div>
        </section>

        <section className="cv-section">
          <h2 className="cv-section-title">Podsumowanie</h2>

          <div className="cv-summary">
            <p>UX/UI Designer | Graphic Designer</p>
            <p>z <span className="cv-summary-highlight">10+ lat</span> doświadczenia, w tym <span className="cv-summary-highlight">ponad 5 lat</span> w <span className="cv-summary-highlight">Siemens Digital Logistics</span> przy projektach logistycznych (SaaS solutions).</p>

            <p>Specjalizuję się w poprawie <span className="cv-summary-highlight">usability, identyfikacji problemów UX i wdrażaniu</span> skalowalnych design systemów.</p>

            <p>Biegłość w <span className="cv-summary-highlight">wireframingu, prototypowaniu i UX research, integracji user insights w strategię produktu</span>.</p>

            <p>Silna <span className="cv-summary-highlight">współpraca z product managerami, inżynierami i interesariuszami</span>, napędzająca data-driven, user-friendly solutions.</p>
          </div>
        </section>

        <section className="cv-section">
          <h2 className="cv-section-title">Umiejętności</h2>

          <div className="cv-skills-list">
            Interface Design | UX Research | Wireframing | Animacja | Agile
          </div>
        </section>

        <section className="cv-section">
          <h2 className="cv-section-title">Narzędzia</h2>

          <ul className="cv-tools-list">
            <li>Figma</li>
            <li>Adobe Creative Suite (Photoshop, Illustrator, InDesign)</li>
            <li>Confluence</li>
            <li>Jira</li>
          </ul>
        </section>

        <section className="cv-section">
          <h2 className="cv-section-title">Szkolenia</h2>

          <ul className="cv-trainings-list">
            <li>
              <span className="cv-training-name">SAFe Training:</span> <span className="cv-training-date">Październik 2024</span>
            </li>
            <li>
              <span className="cv-training-name">Designing For Complex UI</span> <span className="cv-training-date">Luty 2022</span>
              <div className="cv-training-instructor">(Warsztat prowadził Vitaly Friedman)</div>
            </li>
            <li>
              <span className="cv-training-name">Figma course</span> <span className="cv-training-date">Listopad 2021</span>
            </li>
            <li>
              <span className="cv-training-name">(Udemy)</span>
            </li>
            <li>
              <span className="cv-training-name">UX design course</span> <span className="cv-training-date">Październik 2020 - Luty 2021</span>
            </li>
            <li>
              <span className="cv-training-name">(Infoshare Academy)</span>
            </li>
          </ul>
        </section>

        <section className="cv-section">
          <h2 className="cv-section-title">Języki</h2>

          <div className="cv-language">
            <span className="cv-language-name">Angielski:</span> biegły
          </div>
          <div className="cv-language">
            <span className="cv-language-name">Polski:</span> ojczysty
          </div>
        </section>
      </div>
    </div>
  );
}

export default CVPL; 